import { __assign, __rest } from "tslib";
import { CoherencePanelSize } from '@coherence-design-system/utilities';
import { classNamesFunction, Panel, PanelType } from '@fluentui/react';
import { FullPageWizard, SetupWizard } from '@m365-admin/wizard';
import React from 'react';
import { WizardType } from '.';
var getClassNames = classNamesFunction();
export var WizardBase = function (props) {
    var theme = props.theme, type = props.type, _a = props.isNarrow, isNarrow = _a === void 0 ? false : _a, _b = props.isLoading, isLoading = _b === void 0 ? false : _b, otherProps = __rest(props, ["theme", "type", "isNarrow", "isLoading"]);
    var classNames = getClassNames(props.styles, {
        theme: theme,
        isNarrow: isNarrow,
        isLoading: isLoading
    });
    var wizardRender = null;
    switch (type) {
        case WizardType.FULL_PAGE:
            wizardRender = React.createElement(FullPageWizard, __assign({}, otherProps, { theme: theme }));
            break;
        case WizardType.PANEL: {
            var panelProps = otherProps.panelProps;
            wizardRender = (React.createElement(Panel, __assign({ closeButtonAriaLabel: 'Close', customWidth: CoherencePanelSize.large, type: PanelType.custom }, panelProps),
                React.createElement(FullPageWizard, __assign({}, otherProps, { theme: theme }))));
            break;
        }
        case WizardType.SETUP:
            wizardRender = React.createElement(SetupWizard, __assign({}, otherProps, { theme: theme }));
            break;
    }
    return React.createElement("div", { className: classNames.outerWrapper }, wizardRender);
};
//# sourceMappingURL=Wizard.base.js.map